// extracted by mini-css-extract-plugin
export default {"section":"HomeSection_section__KH8Tt","input":"HomeSection_input__wGZEh","btn":"HomeSection_btn__JE2qp","history":"HomeSection_history__KqN+A"};